export default __webpack_public_path__ + "static/media/financial-fund-passcode-340x340.777b9d8a.gif";